import {
  Alert, Button, Checkbox, Divider, Form, Input, message, Space,
} from 'antd';
import React, { useState } from 'react';
import { AiOutlineLock, AiOutlineMail } from 'react-icons/all';
import { useMutation } from '@apollo/client';
import { Link, navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { ACCOUNT_REGISTER } from '../../../graphql/mutations/accountRegister';
import { formItemLayout } from '../utils/form-item-layout';

export const SignUpForm = ({ form }) => {
  const { origin } = useLocation();
  const [alert, setAlert] = useState(null);

  const [accountRegister, { loading }] = useMutation(ACCOUNT_REGISTER, {
    errorPolicy: 'all',
    onCompleted: (data) => {
      if (data?.accountRegister.accountErrors.length === 0) {
        message.success('Account created');
        if (data?.accountRegister.requiresConfirmation) {
          return navigate('/user/auth/confirm/');
        }
        return navigate('/user/account/');
      }
      data.accountRegister.accountErrors.forEach(
        ((err) => {
          setAlert(
            <>
              <Alert message={err.message} type="error" showIcon closable />
              <Divider />
            </>,
          );
        }),
      );
      return null;
    },
  });

  return (
    <Form
      form={form}
      size="large"
      name="register"
      initialValues={{
        remember: true,
      }}
      {...formItemLayout}
      onFinish={(values) => accountRegister({
        variables: {
          email: values.email,
          password: values.password,
          redirectUrl: `${origin}/user/auth/confirm/`,
        },
      })}
    >
      {alert}
      <Form.Item
        name="email"
        label="E-mail"
        hasFeedback
        validateTrigger="onChange"
        rules={[
          {
            type: 'email',
            message: 'Please provide a valid email address.',
          },
          {
            required: true,
            message: 'Please enter a valid email address.',
          },
        ]}
      >
        <Input
          placeholder="example@example.com"
          prefix={<AiOutlineMail />}
        />
      </Form.Item>
      <Form.Item
        name="password"
        label="Password"
        hasFeedback
        validateTrigger="onChange"
        rules={[
          {
            required: true,
            message: 'Please create a password',
          },
          {
            min: 9,
            message: 'Use at least 9 letters, numbers, symbols',
          },
          {
            whitespace: true,
            message: 'Password cannot contain only spaces.',
          },
        ]}
      >
        <Input.Password
          placeholder="Letters, numbers & symbols"
          prefix={<AiOutlineLock />}
        />
      </Form.Item>
      <Form.Item
        name="terms"
        valuePropName="checked"
        style={{ textAlign: 'right' }}
        wrapperCol={{ span: 24 }}
        rules={[
          {
            validator: (rule, value) => {
              if (value) {
                return Promise.resolve();
              }
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject('Please accept the T&C');
            },
          },
        ]}
      >
        <Checkbox>
          I accept the
          {' '}
          <Link to="/about/terms">Terms & Conditions</Link>
        </Checkbox>
      </Form.Item>
      <Space className="form-actions">
        <Form.Item>
          <Button
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Sign Up
          </Button>
        </Form.Item>
      </Space>
    </Form>
  );
};
